export default "__VITE_ASSET__CYjRrdbO__"